import React, { useState } from "react";
import styles from "./Contact.module.css";
import {
  Box,
  InputField,
  SubmitButton,
  TextareaField,
} from "../../../components";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { showAlert } from "../../../Store/Actions/GeneralActions";

const Contact = () => {
  const [queryTitle, setQueryTitle] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.AuthReducer.user);
  const [email, setEmail] = useState(user?.email);

  const submit = () => {
    if (!queryTitle || !message) {
      dispatch(
        showAlert({
          title: "contactUs",
          message: "Please fill all fields!",
          type: "Error",
          status: 400,
        })
      );
    } else {
      let userdata = {
        email: user?.email,
        query_title: queryTitle,
        message,
      };
      dispatch(AuthMiddleware.contactUs(userdata))
        .then(() => {
          setQueryTitle();
          setMessage();
          navigate(-1);
        })
        .catch();
    }
  };
  return (
    <div boxClass={styles.contactContainer}>
      <InputField
        label="Email"
        placeholder={"Email Address"}
        value={email}
        // onChange={(e) => setEmail(e.target.value)}
        disabled={true}
      />
      <InputField
        label="Query Title"
        placeholder={"Query Title"}
        value={queryTitle}
        onChange={(e) => setQueryTitle(e.target.value)}
      />
      {/* <label className={styles.label} htmlFor="messageBox">
        Message Box
      </label>
      <textarea
        className={styles.textarea}
        placeholder="Enter Your Message Here"
        cols="30"
        rows="7"
      /> */}
      <TextareaField
        label={"Message Box"}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={8}
        placeholder={"Enter Your Message Here"}
      />
      <SubmitButton
        btnClass={styles.contactSubmitBtn}
        title={"Submit"}
        onClick={() => submit()}
      />
    </div>
  );
};
export default Contact;
